<div id="top">
  <ecp-login-header-form></ecp-login-header-form>
  <div class="section mt-60">
    <div class="container">
      <div class="row">
        <ecp-widget id="content" class="col s12" title="Content" [loading]="contentLoading">
          <ecp-welcome-content [contentItem]="content?.contentItem"></ecp-welcome-content>
        </ecp-widget>
      </div>
    </div>
  </div>
</div>

